import { ajax } from "@/assets/js/ajax";
export function getDirectory(data) {     //法院目录列表
  return ajax({
    url: 'court/index',
    type: 'get',
    data: data
  })
}

export function directoryDel(data) {     //法院删除
  return ajax({
    url: 'court/del',
    type: 'post',
    data: data
  })
}

export function directoryInfo(data) {     //法院详情
  return ajax({
    url: 'court/info',
    type: 'get',
    data: data
  })
}

export function directoryEdit(data) {     //法院修改
  return ajax({
    //url: 'court/edit',
    url: 'court/editWithAudit',
    type: 'put',
    data: data
  })
}

export function directoryNameEdit(data) {     //法院修改
  return ajax({
    //url: 'court/edit',
    url: 'court/edit',
    data: data
  })
}

export function directoryAdd(data) {     //法院添加
  return ajax({
    url: 'court/add',
    type: 'post',
    data: data
  })
}

export function teamAdd(data) {        //新增团队
  return ajax({
    url: 'team/save',
    data: data
  })
}

export function teamList(data) {        //团队列表
  return ajax({
    url: 'team/index',
    type: 'get',
    data: data
  })
}
export function teamEdit(data) {
  return ajax({
    url: 'team/update',
    data: data
  })
}
export function teamDel(data) {
  return ajax({
    url: 'team/delete',
    data: data,
    type: "get"
  })
}

export function bankList(data) {
  return ajax({
    url: 'bank/index',
    data: data,
    type: "get"
  })
}

export function bankAdd(data) {
  return ajax({
    url: 'bank/add',
    data: data,
  })
}

export function bankEdit(data) {
  return ajax({
    url: 'bank/edit',
    data: data,
    type: 'put'
  })
}
export function bankDel(data) {
  return ajax({
    url: 'bank/del?id=' + data,
    type: 'delete'
  })
}

//代理模式

export function agencyList(data) {
  return ajax({
    url: '/agent/index',
    data: data,
    type: "get"
  })
}

export function agencyAdd(data) {
  return ajax({
    url: 'agent/add',
    data: data,
  })
}

export function agencyEdit(data) {
  return ajax({
    url: 'agent/edit',
    data: data,
    type: 'put'
  })
}
export function agencyDel(data) {
  return ajax({
    url: 'agent/del?id=' + data,
    type: 'delete'
  })
}



// 调解机构

export function arbOrg(data, type) {
  return ajax({
    url: '/arbOrg/' + type,
    data: data,
    type: (type == 'index' || type == 'info') ? "get" : "post"
  })
}
